/*
 * Copyright 2022 StarTree Inc.
 *
 * All rights reserved. Confidential and proprietary information of StarTree Inc.
 */
import { Grid, Typography } from "@material-ui/core";
import InfoIcon from "@material-ui/icons/Info";
import {
    getPlatformUiVersionV1,
    LinkV1,
    NavBarLinkIconV1,
    NavBarLinkTextV1,
    NavBarLinkV1,
    useDialogProviderV1,
} from "@startree-ui/platform-ui";
import { ReactComponent as StarTreeIcon } from "@startree-ui/platform-ui/assets/images/startree-icon-light.svg";
import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { getRemoteManagedUiVersion } from "../../utils/version/version.util";
import { useAboutDialogNavBarButtonStyles } from "./about-dialog-nav-bar-button.styles";

export const AboutDialogNavBarButton: FunctionComponent = () => {
    const aboutDialogNavBarButtonClasses = useAboutDialogNavBarButtonStyles();
    const { visible, showDialog, hideDialog } = useDialogProviderV1();
    const { t } = useTranslation();

    const handleButtonClick = (): void => {
        showDialog({
            headerText: t("label.startree-remote-managed"),
            contents: (
                <Grid container alignItems="center">
                    {/* App logo */}
                    <Grid
                        container
                        item
                        justifyContent="center"
                        spacing={0}
                        xs={3}
                    >
                        <Grid item>
                            <StarTreeIcon
                                className={
                                    aboutDialogNavBarButtonClasses.appLogo
                                }
                            />
                        </Grid>
                    </Grid>

                    <Grid container item xs={9}>
                        {/* Remote Managed UI version */}
                        <Grid item xs={12}>
                            <Typography variant="subtitle2">
                                {t("label.remote-managed-ui")}
                            </Typography>

                            <Typography variant="caption">{`${t(
                                "label.version"
                            )} ${getRemoteManagedUiVersion()}`}</Typography>
                        </Grid>

                        {/* Platform UI version */}
                        <Grid item xs={12}>
                            <Typography variant="subtitle2">
                                {t("label.platform-ui")}
                            </Typography>

                            <Typography variant="caption">{`${t(
                                "label.version"
                            )} ${getPlatformUiVersionV1()}`}</Typography>
                        </Grid>

                        {/* Website */}
                        <Grid item xs={12}>
                            <LinkV1
                                externalLink
                                href={t("url.startree-website")}
                                target="_blank"
                                variant="body2"
                            >
                                {t("url.startree-website")}
                            </LinkV1>
                        </Grid>
                    </Grid>
                </Grid>
            ),
            hideCancelButton: true,
            okButtonText: t("label.ok"),
            onOk: hideDialog,
        });
    };

    return (
        <NavBarLinkV1 selected={visible} onClick={handleButtonClick}>
            <NavBarLinkIconV1>
                <InfoIcon />
            </NavBarLinkIconV1>

            <NavBarLinkTextV1>{t("label.about")}</NavBarLinkTextV1>
        </NavBarLinkV1>
    );
};
